function qPath(id, localePath) {
  return `${typeof localePath === 'string' ? localePath : ''}/${id}`;
}

module.exports = qPath;
